RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmailList = Marionette.CompositeView.extend({
        ui: {
            input: 'input',
            wrapper: '.x-landscape-email-address-wrapper',
            helpText: '.help-block'
        },
        events: {
            'click .x-landscape-add-email': 'addEmail',
            'click .x-landscape-manage-all': 'manageAllLandscapes',
            'keypress input': 'checkForAdd'
        },
        collectionEvents: {
            add: 'onRender',
            remove: 'onRender'
        },
        childView: RivalIQ.apps.LandscapeSettings.views.Email,
        childViewContainer: 'tbody',
        template: '#notificationEmailListTemplate',
        onRender: function () {
            const me = this;
            const wrapper = me.ui.wrapper;

            if (me.collection.length > 0) {
                wrapper.removeClass('hide');
            } else {
                wrapper.addClass('hide');
            }
        },
        addEmail: function () {
            const me = this;
            const model = me.model;
            const input = me.ui.input;
            const email = $.trim(input.val()).toLowerCase();
            const ownEmail = $.trim(model.get('email')).toLowerCase();
            me.ui.helpText.hide();

            if (email !== ownEmail && !me.hasEmail(email) && me.isLikeEmail(email)) {
                me.saveEmail(email);
                input.val('').focus();
            } else {
                me.ui.helpText.show();
            }
        },
        checkForAdd: function (e) {
            if (e.keyCode === 13) {
                this.addEmail();
                return false;
            }
        },
        // do a rudimentary check to make sure some jerk isn't writing html
        isLikeEmail: function (email) {
            return email.match(/.+@.+/) && !email.match(/<|>/g);
        },
        hasEmail: function (email) {
            return this.collection.where({
                email: email
            }).length > 0;
        },
        getStateManager: function () {
            // landscape settings
            return RivalIQ.state.landscape;
        },
        saveEmail: function (email) {
            const me = this;
            let emailSettings = me.getStateManager().get('emailSettings');

            if (!emailSettings) {
                emailSettings = {};
            }
            if (!emailSettings.additionalAddresses) {
                emailSettings.additionalAddresses = [];
            }
            emailSettings.additionalAddresses.push(email);

            // update central state
            me.getStateManager().set('emailSettings', emailSettings);

            // update local model
            me.collection.add({
                email: email,
                isVerified: false
            });
        },
        manageAllLandscapes: function () {
            const me = this;
            let emailListModal = me.emailListModal;

            if (!emailListModal) {
                emailListModal = me.emailListModal = new RivalIQ.apps.LandscapeSettings.views.EmailListModal({
                    model: me.model,
                    collection: RivalIQ.apps.LandscapeSettings.collections.Email.createFromSettings(RivalIQ.state.account.get('emailSettings'))
                });
                $(document.body).append(emailListModal.$el);
            }

            emailListModal.render();

            return false;
        }
    });
});
